import $ from 'jquery'
import { Alert } from '../functions'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';

FilePond.setOptions(fr_fr);
FilePond.registerPlugin(FilePondPluginFileValidateType);

const object = vnObject;

const pondCv = FilePond.create(document.querySelector('.filepond-cv'), {
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const pondCoverLetter = FilePond.create(document.querySelector('.filepond-cover-letter'), {
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const fileErrorCv = $('#js-filepond-cv-error-container');
pondCv.on('addfile', (event) => {
    fileErrorCv.html('')
});

pondCv.on('removefile', (event) => {
    fileErrorCv.html(fileErrorCv.attr('data-error-message'))
});

const fileErrorCoverLetter = $('#js-filepond-cover-letter-error-container');
pondCoverLetter.on('addfile', (event) => {
    fileErrorCoverLetter.html('')
});

pondCoverLetter.on('removefile', (event) => {
    fileErrorCoverLetter.html(fileErrorCoverLetter.attr('data-error-message'))
});

var applicationForm = $('.application-form')
applicationForm.parsley()

applicationForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const $form = $(this)

    const formData = new FormData($(this)[0])
    formData.append('action', 'vn_application')
    var pondCvFiles = pondCv.getFiles();
    formData.append('cv', pondCvFiles[0].file);
    var pondCoverLetterFiles = pondCoverLetter.getFiles();
    formData.append('cover_letter', pondCoverLetterFiles[0].file);

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: () => {
            $form.addClass('sending')
            Alert('warning', object.formWait, false)
        },
        success: (res) => {
            $form.removeClass('sending')

            if (res.success && res.data.redirect) {
                window.location = res.data.redirect
            }

            if (!res.success) {
                Alert(res.success, res.data.message)
            }
        },
    })
})
